import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_app/$module_id/$entity_type_id/$entity_id/_tabs/send/$documentTemplateId',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div>
      Hello
      "/_app/$module_id/$entity_type_id/$entity_id/_tabs/send/$documentTemplateId"!
    </div>
  )
}
